import { createContext, useContext, useState, useEffect } from "react";
import { login as apiLogin } from "../services/api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const storedUser = sessionStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    const login = async (username, password) => {
        try {
            const data = await apiLogin(username, password);
            if (data.success) {
                const { accessKey, menus, rollName } = data.domain_Info; // ✅ Extract rollName
                const loggedInUser = {
                    username: data.domain_Info.username || username, // ✅ Use API username if available
                    role: rollName || "Unknown", // ✅ Use rollName from API
                    menus: menus || []
                };

                sessionStorage.setItem("authToken", accessKey);
                sessionStorage.setItem("user", JSON.stringify(loggedInUser));
                setUser(loggedInUser);
                return true;
            }
        } catch (error) {
            console.error("❌ Login failed:", error);
            return false;
        }
    };

    const logout = () => {
        sessionStorage.clear(); // ✅ Clears all session data
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
